import { render } from "./pm_list.vue?vue&type=template&id=61b0b248&scoped=true"
import script from "./pm_list.vue?vue&type=script&lang=js"
export * from "./pm_list.vue?vue&type=script&lang=js"

import "./pm_list.vue?vue&type=style&index=0&id=61b0b248&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b0b248"]])

export default __exports__